import React from 'react';
import { Row, Col } from 'antd';
import StatCard from './StatCard';

/**
 * Global Statistics Card Component
 * Reusable statistics display for all modules (Staff, Customers, Transactions, etc.)
 * 
 * @param {Array} cardData - Array of card configurations
 * @param {boolean} isLoading - Loading state
 * @param {boolean} isError - Error state
 * @param {string} errorMessage - Error message
 * @param {string} errorType - Type of error for context
 * @param {number} columns - Number of columns (default: 3)
 * @param {Array} gutter - Gutter spacing (default: [16, 16])
 * @param {Object} ...props - Additional props
 */
const StatisticsCard = ({
  cardData = [],
  isLoading = false,
  isError = false,
  errorMessage = 'An error occurred',
  errorType = 'data',
  columns = 3,
  gutter = [16, 16],
  ...props
}) => {
  // Loading skeleton
  if (isLoading) {
    return (
      <Row gutter={gutter} {...props}>
        {Array.from({ length: columns }, (_, index) => (
          <Col xs={24} sm={12} md={24 / columns} key={index}>
            <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center space-x-4 shadow-sm">
              <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"></div>
              <div className="flex flex-col">
                <div className="h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
                <div className="h-6 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    );
  }

  // Error state
  if (isError) {
    return (
      <Row gutter={gutter} {...props}>
        <Col span={24}>
          <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
            <p className="text-red-600">
              Error loading {errorType} data: {errorMessage}
            </p>
          </div>
        </Col>
      </Row>
    );
  }

  // Render statistics cards
  return (
    <Row gutter={gutter} {...props}>
      {cardData.map((stat, index) => (
        <Col xs={24} sm={12} md={24 / columns} key={index}>
          <StatCard
            icon={stat.icon}
            title={stat.title}
            count={stat.count}
            iconColor={stat.iconColor}
            iconBgColor={stat.iconBgColor}
            trend={stat.trend}
            trendValue={stat.trendValue}
            onClick={stat.onClick}
            loading={stat.loading}
            {...stat}
          />
        </Col>
      ))}
    </Row>
  );
};

export default StatisticsCard;
